<template>
    <div class="panel panel-default">
        <div class="inspection-tab-white">
            <div class="row">
                <div class="col-lg-5">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>Основные</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody v-if="inspection_main">
                        <tr>
                            <td>Марка</td>
                            <td>{{ inspection_main.inspection.brand.name }}</td>
                        </tr>
                        <tr>
                            <td>Модель</td>
                            <td>{{ inspection_main.inspection.model.name }}</td>
                        </tr>
                        <tr>
                            <td>ФИО</td>
                            <td>{{ inspection_main.inspection.name }} {{ inspection_main.inspection.last_name }} {{ inspection_main.inspection.middle_name }}</td>
                        </tr>
                        <tr>
                            <td>Телефон</td>
                            <td>{{ inspection_main.inspection.phone }}</td>
                        </tr>
                        <tr>
                            <td>E-mail</td>
                            <td>{{ inspection_main.inspection.email }}</td>
                        </tr>
                        <tr>
                            <td>Тип кузова</td>
                            <td>{{inspection_main.body_type.name}}</td>
                        </tr>
                        <tr>
                            <td>Нестандартный кузова</td>
                            <td>{{ (inspection_main.custom_body) ? 'Да' : 'Нет' }}</td>
                        </tr>
                        <tr>
                            <td>Количество дверей</td>
                            <td>{{ (inspection_main.door != null) ? inspection_main.door.name : '' }}</td>
                        </tr>
                        <tr>
                            <td>Количество мест</td>
                            <td>{{ (inspection_main.seat != null) ? inspection_main.seat.name : '' }}</td>
                        </tr>
                        <tr>
                            <td>Год производства</td>
                            <td>{{inspection_main.year}}</td>
                        </tr>
                        <tr>
                            <td>Цвет кузова</td>
                            <td v-if="inspection_main.color">{{inspection_main.color.name}}</td>
                            <td v-else>{{inspection_main.other_color}}</td>
                        </tr>
                        <tr>
                            <td>Пробег, {{(inspection_main.inspection.mileage_type == 'KILOMETER') ? 'км' : 'мили'}}</td>
                            <td>{{inspection_main.inspection.mileage}}</td>
                        </tr>
                        <tr>
                            <td>Фотография щитка приборной панели</td>
                            <td v-if="inspection_main.photo_dashboard_panel != null">
                                <a :href="`${ inspection_main.photo_dashboard_panel }`" type="image/png" target="_blank">
                                    <img :src="`${ inspection_main.photo_dashboard_panel }`" class="main_photo" alt="Фотография щитка приборной панели">
                                </a>
                            </td>
                            <td v-else>Фото отсутствует</td>
                        </tr>
                        <tr>
                            <td>Тип двигателя</td>
                            <td>{{inspection_main.engine_type.name}}</td>
                        </tr>
                        <tr>
                            <td>Мощность, лс</td>
                            <td>{{inspection_main.engine_power}}</td>
                        </tr>
                        <tr>
                            <td>Рабочий объем, см3</td>
                            <td>{{ (inspection_main.engine_capacity != null) ? inspection_main.engine_capacity : '' }}</td>
                        </tr>
                        <tr>
                            <td>Тип привода</td>
                            <td>{{inspection_main.drive_type.name}}</td>
                        </tr>
                        <tr>
                            <td>Тип трансмиссии</td>
                            <td>{{inspection_main.transmission_type.name}}</td>
                        </tr>
                        <tr>
                            <td>ПТС</td>
                            <td>{{ (inspection_main.pts) ? 'Оригинал' : 'Дубликат' }}</td>
                        </tr>
                        <tr>
                            <td>Количество владельцев</td>
                            <td>{{ (inspection_main.number_owners != null) ? inspection_main.number_owners : '' }}</td>
                        </tr>
                        <tr>
                            <td>Источник покупки</td>
                            <td v-if="inspection_main.source_purchase == 'dealer'">Дилер</td>
                            <td v-else-if="inspection_main.source_purchase == 'no'">Нет</td>
                            <td v-else-if="inspection_main.source_purchase == 'gray_import'">Серый импорт</td>
                        </tr>
                        <tr>
                            <td>Гарантия</td>
                            <td v-if="inspection_main.guarantee != null">{{ (inspection_main.guarantee) ? 'Да' : 'Нет' }}</td>
                            <td v-else></td>
                        </tr>
                        <tr>
                            <td>Покупка</td>
                            <td v-if="inspection_main.purchase == 'credit'">Кредит</td>
                            <td v-else-if="inspection_main.purchase == 'leasing'">Лизинг</td>
                            <td v-else-if="inspection_main.purchase == 'own_funds'">Собственные средства</td>
                        </tr>
                        <tr>
                            <td>Диагностическая карта</td>
                            <td>{{ (inspection_main.diagnostic_card) ? 'Да' : 'Нет' }}</td>
                        </tr>
                        <tr v-if="inspection_main.diagnostic_card">
                            <td>Дата действия диагностической карты</td>
                            <td v-if="inspection_main.diagnostic_card_valid_at != null">{{ inspection_main.diagnostic_card_valid_at | date_format('DD.MM.YYYY') }}</td>
                        </tr>
                        <tr>
                            <td>Номер полиса ОСАГО</td>
                            <td>{{ (inspection_main.number_osago_policy != null) ? inspection_main.number_osago_policy : '' }}</td>
                        </tr>
                        <tr>
                            <td>Наименование страховой</td>
                            <td>{{ (inspection_main.insurance_company != null) ? inspection_main.insurance_company.name : '' }}</td>
                        </tr>
                        <tr>
                            <td>Охранная система</td>
                            <td>{{ (inspection_main.security_system) ? 'Да' : 'Нет' }}</td>
                        </tr>
                        <tr>
                            <td>Спутниковая система</td>
                            <td>{{ (inspection_main.satellite) ? 'Да' : 'Нет' }}</td>
                        </tr>
                        <tr>
                            <td>Система с GSM</td>
                            <td>{{ (inspection_main.gsm) ? 'Да' : 'Нет' }}</td>
                        </tr>
                        <tr>
                            <td>Дистанционный запуск</td>
                            <td>{{ (inspection_main.remote_start) ? 'Да' : 'Нет' }}</td>
                        </tr>
                        <tr>
                            <td>Наименование охраны</td>
                            <td>{{ (inspection_main.name_security_system != null) ? inspection_main.name_security_system : '' }}</td>
                        </tr>
                        <tr>
                            <td>Номер СТС</td>
                            <td>{{ (inspection_main.number_sts != null) ? inspection_main.number_sts : '' }}</td>
                        </tr>
                        <tr>
                            <td>Фотография СТС</td>
                            <td v-if="inspection_main.photo_sts != null">
                                <a :href="`${ inspection_main.photo_sts }`" type="image/png" target="_blank">
                                    <img :src="`${ inspection_main.photo_sts }`" class="main_photo" alt="Фотография СТС">
                                </a>
                            </td>
                            <td v-else>Фото отсутствует</td>
                        </tr>
                        <tr>
                            <td>Фотография СТС 2</td>
                            <td v-if="inspection_main.photo_sts_2 != null">
                                <a :href="`${ inspection_main.photo_sts_2 }`" type="image/png" target="_blank">
                                    <img :src="`${ inspection_main.photo_sts_2 }`" class="main_photo" alt="Фотография СТС 2">
                                </a>
                            </td>
                            <td v-else>Фото отсутствует</td>
                        </tr>
                        <tr>
                            <td>Дата последнего обслуживания</td>
                            <td v-if="inspection_main.last_serviced_at != null">{{ inspection_main.last_serviced_at | date_format('DD.MM.YYYY') }}</td>
                            <td v-else>не обслуживалась</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-lg-3 second_bordered">
                    <div class="bordered-container">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th colspan="2">Осмотр провел</th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_main">
                            <tr>
                                <td>Логин</td>
                                <td>{{ inspection_main.inspection.user.login }}</td>
                            </tr>
                            <tr>
                                <td>ФИО</td>
                                <td>{{ inspection_main.inspection.user.full_name }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="bordered-container">
                        <table class="table table-striped" id="stat-table">
                            <thead>
                            <tr>
                                <th colspan="3">Статистика</th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_main">
                            <tr>
                                <td>Дата осмотра</td>
                                <td colspan="2" width="66%">{{ inspection_main.inspection.completed_at }}</td>
                            </tr>
                            <!--<tr>-->
                                <!--<td>Количество неисправностей</td>-->
                                <!--<td>&nbsp;</td>-->
                                <!--<td>4</td>-->
                            <!--</tr>-->
                            <tr>
                                <td colspan="2" width="66%">Длительность осмотра</td>
                                <td>{{ inspection_main.inspection.duration }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="bordered-container">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>Адрес осмотра</th>
                            </tr>
                            </thead>
                            <tbody v-if="inspection_main">
                            <tr>
                                <td>{{ inspection_main.address }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <gmap-map :center="center" :streetViewControl="false" :zoom="15"
                                              style="width: 100%; height: 200px">
                                        <google-cluster>
                                            <gmap-marker
                                                    :key="index"
                                                    v-for="(m, index) in markers"
                                                    :position="m.position"
                                                    :clickable="true"
                                                    :draggable="true"
                                                    @click="center=m.position"
                                            ></gmap-marker>
                                        </google-cluster>
                                    </gmap-map>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-lg-4 car_comment">
                    <h2>Комментарий к автомобилю</h2>
                    <div class="comment_body" v-if="inspection_main">{{ inspection_main.comment }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        name: 'InspectionMain',
        props: ['inspection_id'],
        data () {
            return {
                center: {lat: 85, lng: 90},//{lat: 59.937387, lng: 30.3298673},
                markers: [],
            }
        },
        asyncComputed: {
            inspection_main() {
                return axios
                    .get('/api/inspections/' + this.inspection_id + '/main', {
                        params: {}
                    })
                    .then(({data}) => {
                        this.markers = [{position: {lat: (data.lat == null) ? this.center.lat : parseFloat(data.lat), lng: (data.lng == null) ? this.center.lng : parseFloat(data.lng)}}]; // создаем метку по координатам из бд
                        this.center = this.markers[0].position; // центрируем карту по точке
                        return data
                    })
            },
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// InspectionMain.vue?18b82f84